<template>
<!-- grid-densa: ancora do teste de 9px SO nas grids desta tela. Ver scss/_custom.scss. -->
<div class="grid-densa">
  <!-- ZC-39: acima das abas fica SO a grade de empresas (`apenas-empresas`). Os 6 cards, o donut
       e o gasto por moeda continuam no componente — vao para o submenu Dashboard do ZPag.
       O slot left-prestacao (Total de Despesas + ExpenseSearch) fica intacto: e a unica busca por
       periodo/situacao da tela, e e por ela que o filtro do clique na sigla passa. -->
  <VisaoGeralDespesas
    v-if="mostraVisaoGeral"
    :apenas-empresas="true"
    @navegar="onNavegar"
    ref="VisaoGeralDespesasRef" />
  <mv-tabs :tabsHeaders="tabsHeaders" @tabs="tabs = $event">
    <template #left-prestacao>
      <div class="d-flex justify-content-center mt-2 title-card-sales">
        Total de Despesas
      </div>
        <div class="sales-value">{{ formatMoney(totalDespesas) }}</div>
      <div class="mt-2">
        <ExpenseSearch ref="ExpenseSearchRef" @search="search"></ExpenseSearch>
      </div>
    </template>
    <template #tab-prestacao>
      <TableTravelExpense
              @totalDespesas="totalDespesas = !$event ? 0 : $event"
              @localidade="localidade = !$event ? 0 : $event"
              :prestacao="prestacao"
              ref="TableTravelExpense"/>
    </template>
    <template #left-colaboradores>
       <FilterTravelContributor @search="search"></FilterTravelContributor>
    </template>
    <template #tab-colaboradores v-if="hasRole(roles.RW_REAL_ESTA_ADMIN) || hasRole(roles.ACC_FIN_TRAVELLANEOUS_SEARCH_CONTROLLER_APPROVAL)">
      <CollaboratorTableTravelExpense @AtualizaPrestacao="AtualizaPrestacao" v-if="aba === 'colaboradores'" ref="CollaboratorTableTravelExpenseRef"/>
    </template>
    <template #left-lotes>
        <FilterLotsPaid @search="search"></FilterLotsPaid>
    </template>
    <template #tab-lotes v-if="hasRole(roles.RW_REAL_ESTA_ADMIN) || hasRole(roles.ACC_FIN_TRAVELLANEOUS_SEARCH_CONTROLLER_APPROVAL)">
      <LotsPaid  v-if="aba === 'lotes'" ref="LotsPaidRef"/>
    </template>

    <template #left-primeiroAdiantamento>
        <FilterAdvanceFirstTrip @search="search"></FilterAdvanceFirstTrip>
    </template>
    <template #tab-primeiroAdiantamento v-if="hasRole(roles.RW_REAL_ESTA_ADMIN) || hasRole(roles.ACC_FIN_TRAVELLANEOUS_SEARCH_CONTROLLER_APPROVAL)">
        <AdvanceFirstTrip v-if="aba === 'primeiroAdiantamento'" ref="AdvanceFirstTripRef"></AdvanceFirstTrip>
    </template>

    <template #left-desligamento>
        <FilterTravelContributor @search="search"></FilterTravelContributor>
    </template>
    <template #tab-desligamento v-if="podeDesligamento">
        <Detailscollaborator v-if="aba === 'desligamento'" ref="DetailscollaboratorRef"></Detailscollaborator>
    </template>

  </mv-tabs>
</div>
</template>
<script>
import ExpenseSearch from './components/ExpenseSearch/ExpenseSearch.vue'
import FilterTravelContributor from './components/FilterTravelsContributor/FilterTravelsContributor.vue'
import TableTravelExpense from './components/Tabs/tabletravelexpense/tabletravelexpense.vue'
import LotsPaid from './components/Tabs/LotsPaid/LotsPaid.vue'
import AdvanceFirstTrip from './components/Tabs/AdvanceFirstTrip/AdvanceFirstTrip.vue'
import FilterLotsPaid from './components/Tabs/LotsPaid/components/filterLotsPaid.vue'
import FilterAdvanceFirstTrip from './components/Tabs/AdvanceFirstTrip/components/FilterAdvanceFirstTrip.vue'
import ActionsForm from '@/shared/mixins/actionsForm'
import Tools from '@/components/tools/Tools.js'
import MvTabs from './components/MvTabs/MvTabs.vue'
import VisaoGeralDespesas from './components/VisaoGeralDespesas/VisaoGeralDespesas.vue'
// import filterForm from './components/Tabs/CollaboratorTableTravelExpense/components/CollaboratorTableTravelExpenseEmploye/components/filterForm.vue'
import CollaboratorTableTravelExpense from './components/Tabs/CollaboratorTableTravelExpense/CollaboratorTableTravelExpense.vue'
import Detailscollaborator from '@/views/private/miscellaneousreimbursement/components/detailscollaborator/detailscollaborator.vue'
export default {
  name: 'TravelExpenseZpag',
  components: { FilterLotsPaid, FilterAdvanceFirstTrip, AdvanceFirstTrip, LotsPaid, ExpenseSearch, FilterTravelContributor, TableTravelExpense, MvTabs, CollaboratorTableTravelExpense, Detailscollaborator, VisaoGeralDespesas },
  mixins: [ActionsForm],
  computed: {
    // Processo de desligamento: Controladoria e tambem o coordenador de Viagem (pedido de 2026-09-25,
    // caso do JOSE.MANOEL — 93 contas tinham o perfil de coordenador e so viam Prestacao de Conta).
    podeDesligamento () {
      return this.hasRole(this.roles.RW_REAL_ESTA_ADMIN) ||
             this.hasRole(this.roles.ACC_FIN_TRAVELLANEOUS_SEARCH_CONTROLLER_APPROVAL) ||
             this.hasRole(this.roles.ACC_FIN_TRAVELCOORDINATORLANEOUS_SEARCH_CONTROLLER_APPROVAL)
    },
    // chave da aba ativa: o indice muda por usuario (as abas dependem de role)
    aba () {
      var h = this.tabsHeaders[this.tabs]
      return h ? h.slot : null
    },
    // Aparece em TODA empresa, nao so na Zopone. O gate de codigoz 1 foi retirado em 03/09 a pedido
    // do Rodrigo: o clique agora troca de empresa NESTA aba, e sem a grade em toda empresa nao ha
    // como voltar para a base.
    mostraVisaoGeral () {
      return this.hasRole(this.roles.RW_REAL_ESTA_ADMIN) ||
             this.hasRole(this.roles.ACC_FIN_TRAVELLANEOUS_SEARCH_CONTROLLER_APPROVAL)
    }
  },
  data () {
    return {
      totalDespesas: 0,
      prestacao: false,
      tabs: 0,
      tabsHeaders: []
    }
  },
  mounted () {
    this.verifica()
  },
  methods: {
    verifica () {
      var controladoria = this.hasRole(this.roles.RW_REAL_ESTA_ADMIN) || this.hasRole(this.roles.ACC_FIN_TRAVELLANEOUS_SEARCH_CONTROLLER_APPROVAL)
      var abas = [{title: 'Prestação de Conta', icon: 'fas fa-file-contract', slot: 'prestacao'}]
      if (controladoria) {
        abas.push(
          {title: 'Colaboradores', icon: 'fas fa-user', slot: 'colaboradores'},
          {title: 'Lotes Pagos', icon: 'fa fa-table', slot: 'lotes'},
          {title: 'Primeiro Adiantamento', icon: 'far fa-money-bill-alt', slot: 'primeiroAdiantamento'})
      }
      if (this.podeDesligamento) {
        abas.push({title: 'Processo de desligamento', icon: 'fas fa-file-contract', slot: 'desligamento'})
      }
      this.tabsHeaders = abas
    },
    // O painel ja trocou a empresa (sessionStorage + Vuex) antes de emitir. Aqui a tela recarrega
    // no escopo novo. `status` null = clique no cartao (traz tudo); com valor = clique na sigla.
    // Passa pelo ExpenseSearch em vez de chamar `search()` direto para o select de Situacao mostrar
    // o filtro que esta valendo e o `localStoreHelper` persistir — senao a tela filtra e o formulario
    // diz "Selecione", que e a mesma incoerencia de numero que o Rodrigo pegou em 02/09.
    onNavegar ({ status }) {
      const busca = this.$refs.ExpenseSearchRef
      if (busca) {
        busca.form.situacao.value = status
        busca.Search()
        return
      }
      // aba sem o ExpenseSearch montado: aplica direto no escopo da aba ativa
      this.search({ FuncionarioId: null, Situacao: status, CoordenadorId: null, EmpresaId: null, ObraId: null })
    },
    search (data) {
      if (this.aba === 'prestacao') {
        this.$refs.TableTravelExpense.dataSearch = data
        this.$refs.TableTravelExpense.onLoad()
      }
      if (this.aba === 'colaboradores') {
        this.$refs.CollaboratorTableTravelExpenseRef.dataSearch = data
        this.$refs.CollaboratorTableTravelExpenseRef.Onload()
      }
      if (this.aba === 'lotes') {
        this.$refs.LotsPaidRef.dataSearch = data
        this.$refs.LotsPaidRef.Onload()
      }
      if (this.aba === 'primeiroAdiantamento') {
        this.$refs.AdvanceFirstTripRef.dataSearch = data
        this.$refs.AdvanceFirstTripRef.Onload()
      }
      if (this.aba === 'desligamento') {
        this.$refs.DetailscollaboratorRef.formSearch = data
        this.$refs.DetailscollaboratorRef.onLoad()
      }
    },
    formatMoney (value) {
      return Tools.formatMoney(value)
    },
    AtualizaPrestacao (value) {
      this.prestacao = value
    }
  }
}
</script>

<style scoped>
.left-container {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  min-height: 125px;
  border-radius: 8px;
}
.title-card-sales {
  font-size: 24px;
  background: #008144;
  padding: 20px;
  border-radius: 8px 8px 0px 0px;
  color: white;
  font-weight: bold;
}
.sales-value {
  width: 100%;
  height: auto;
  min-height: 60px;
  padding: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 28px;
  font-weight: bold;
  background-color: white;
  border-radius: 0px 0px 8px 8px;
  margin-top: 0px;
}
</style>



// WEBPACK FOOTER //
// src/views/private/finance/expenses/travelexpensezpag/travelexpensezpag.vue